<template>

</template>

<script>
import axios from "axios";
import Qs from "qs";
import { Devicestate } from "../../deviceApi/index.js";
import store from '../../store/store.js'
export default{
	name:'jump',
	data(){
		return{

		}
	},
	mounted(){
		this.jump();
	},
	created(){
		
	},
	watch:{
		
	},
	methods: {
		jump(){
			var ua = navigator.userAgent.toLowerCase();
            var isWeixin = ua.indexOf('micromessenger') != -1;
            var isAndroid = ua.indexOf('android') != -1;
            var isIos = (ua.indexOf('iphone') != -1) || (ua.indexOf('ipad') != -1);
            let deviceCode = this.GetQueryString("deviceCode")||this.GetQueryString("id");
            console.log(deviceCode)
            let fromapp = this.GetQueryString("from");
            var token = this.GetQueryString("accessToken");
            var tokens = this.GetUrlParam("accessToken");
            var lang = this.GetQueryString("lang");
            if(fromapp){
            	localStorage.setItem('token',token);
            	sessionStorage.setItem('token',token);
            	localStorage.setItem('fromapp',fromapp);
            	localStorage.setItem('locale',lang);
            	sessionStorage.setItem('storeLang',lang);
            	if (sessionStorage.getItem('token')) {
			    store.commit('set_token', sessionStorage.getItem('token'))
				}
            	if(deviceCode){
            		this.Devicestate(deviceCode);
            	}else{
	            	setTimeout(() => {
	            	window.location.href='/mytag';
	            	}, 200);	
            	}
            }
              else if (isWeixin) {
				window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb595c21e93322a1a&redirect_uri=http://apicn.dognessnetwork.com/service/authentication/login/wechat/web&response_type=code&scope=snsapi_userinfo&state=deviceCode_"+deviceCode+"#wechat_redirect";
            } else if (isAndroid){
				this.$router.push('/login?deviceCode='+deviceCode);
			} else if (isIos){
				this.$router.push('/login?deviceCode='+deviceCode);
			}
		},
//获取设备详情
	Devicestate(code){
			console.log('判断设备')
		    if(location.href.indexOf("#reloaded")==-1){
		        location.href=location.href+"#reloaded";
		        location.reload();
		    }
			var params = Qs.stringify({
	        	deviceCode: code
	        });
			Devicestate(params)
				.then(res => {
	         	if (res.data.header.status == 1000) {
	         		if(res.data.data==1){
	         			console.log('设备可以绑定')
						this.$router.push({
			                name: "activation",
			                query: {
			                  accessToken: localStorage.token,
			                  deviceCode: code
			                }
	          			});
	         		}else{
	         			console.log('设备已经绑定')
	         			this.$router.push({
			                name: "showInformation",
			                query: {
			                  accessToken: localStorage.token,
			                  deviceCode: code
			                }
		              	});      
	         		}
	         	}else{
	         		  this.$alert("<p>" + res.data.header.message + "</p>", {
						confirmButtonText: this.$t("prompt.sure"),
						dangerouslyUseHTMLString: true
						});
	         	}
	        })
	        .catch(error => {
	          console.log(error);
	        });
			},
//获取url参数带转换=========
  	GetQueryString(name){
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  unescape(r[2]); return null;
		},
//=======获取url指定参数不带转换====
		GetUrlParam(paraName){
		　　　　var url = document.location.toString();
		　　　　var arrObj = url.split("?");
		　　　　if (arrObj.length > 1) {
		　　　　　　var arrPara = arrObj[1].split("&");
		　　　　　　var arr;
		　　　　　　for (var i = 0; i < arrPara.length; i++) {
		　　　　　　　　arr = arrPara[i].split("=");
		　　　　　　　　if (arr != null && arr[0] == paraName) {
		　　　　　　　　　　return arr[1];
		　　　　　　　　}
		　　　　　　}
		　　　　　　return "";
		　　　　}
		　　　　else {
		　　　　　　return "";
		　　　　}
		　　},
		
	}
}
	
	
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/m_page/login/jump.vue